import { CLOUDINARY_PREFIX, GRADIENT_TYPES, MOCK_UP_LAYERS } from '../constants';

const {
    IMAGE_LAYER,
    VARIATION_LAYER,
    GRADIENT_LAYER
} = MOCK_UP_LAYERS;

const CUP_LIGHT = `${CLOUDINARY_PREFIX}ff1d6d498eb4ee244cb6d9c3d9c3ddb7-1577716967568/Light.png`;
const CUP_BASE = `${CLOUDINARY_PREFIX}2a8442e4bb91a7fdf6d0c18041797639-1577716897314/Pen.png`;
const CUP_HIGHLIGHTS = `${CLOUDINARY_PREFIX}2a8442e4bb91a7fdf6d0c18041797639-1577716897292/Highlights.png`;
const BUSINESS_CARD = `${CLOUDINARY_PREFIX}2a8442e4bb91a7fdf6d0c18041797639-1577716897287/Business%20card.png`;

const VARIATION_TRANSFORM = 'translate(-54.7%, -35%) rotate(-19deg) scale(0.20)';

export const cupMockUp = {
    layers: [
        {
            type: IMAGE_LAYER,
            src: CUP_BASE
        }, {
            type: GRADIENT_LAYER,
            mixBlendMode: 'multiply',
            gradientType: GRADIENT_TYPES.LINEAR
        }, {
            type: VARIATION_LAYER,
            transform: VARIATION_TRANSFORM
        }, {
            type: VARIATION_LAYER,
            transform: VARIATION_TRANSFORM,
            opacity: 0.2,
            mixBlendMode: 'multiply'
        }, {
            type: IMAGE_LAYER,
            src: BUSINESS_CARD
        }, {
            type: IMAGE_LAYER,
            opacity: 0.8,
            mixBlendMode: 'overlay',
            src: CUP_HIGHLIGHTS
        }, {
            type: IMAGE_LAYER,
            opacity: 0.44,
            mixBlendMode: 'screen',
            src: CUP_LIGHT
        }
    ],
    aspectRatio: '71.84%'
};
